import React, { useEffect, useState, useCallback } from 'react';
import '../../styles/globals.css'
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, CircularProgress, Grid, Paper, TextField, Typography } from '@mui/material'

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import karmaStyles from '../../styles/KarmaPool.module.css'
import DashboardMenuHeaderComponent from './header/DashboardMenuHeaderComponent';
import DashboardLogoutFooterComponent from './footer/DashboardLogoutFooterComponent';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';
import NoteComponent from './social/notes/NoteComponent';
import TagComponent from './social/tags/TagComponent';
import { Link } from 'react-router-dom';
import NoteChoiceComponent from './social/notes/NoteSubmissionChoiceComponent';
import PagingComponent from './social/paging/PagingComponent';


function DisplayNoteGrid({ latestNotes }) {
    const karmaContext = useKarmaPoolContext();

    return (
        <Box sx={{ marginBottom: "1.0rem", width: "100%", display: "flex", justifyContent: "center" }}>
            <Grid container spacing={2}>
                {latestNotes != null && latestNotes.length > 0 ? (
                    <>
                        {latestNotes.map((note) => {
                            return (
                                <Grid item key={note.id} xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                    <NoteComponent note={note} />
                                </Grid>
                            );
                        })}
                    </>) :
                    (karmaContext.noteManager.isLoadingNotes() ?
                        <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Typography variant="body2" component="div" gutterBottom sx={{ color: "rgba(221, 221, 221, 0.375)" }}>
                                <CircularProgress variant="indeterminate" size={24} sx={{ color: "rgba(221, 221, 221, 0.775)" }} />
                            </Typography>
                        </Grid>
                        :
                        (latestNotes === null ?
                            (
                                <></>
                            )
                            :
                            (
                                <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>

                                </Grid>
                            )
                        ))}
            </Grid>
        </Box>
    );
}

function DisplayNoteFilters(props) {
    const [followingFilter, setFollowingFilter] = useState("EVERYONE");
    const [topFilter, setTopFilter] = useState("ALL");

    return (

        <Box sx={{ marginBottom: "1.5rem", width: "100%", justifyContent: "center" }}>
            <DisplayNoteFollowingFilters setLatestNotes={props.setLatestNotes} followingFilter={followingFilter} setFollowingFilter={setFollowingFilter} />
            <DisplayNoteTopFilters setLatestNotes={props.setLatestNotes} topFilter={topFilter} setTopFilter={setTopFilter} />
            {topFilter === "BLAH" ?
                <DisplayNoteMoodFilters setLatestNotes={props.setLatestNotes} followingFilter={followingFilter} />
                : <></>}
        </Box>
    );
}

function DisplayNoteFollowingFilters({ setFollowingFilter, followingFilter }) {
    const karmaContext = useKarmaPoolContext();

    function onClick(filterValue) {
        setFollowingFilter(filterValue);
        karmaContext.noteManager.setFollowingOnly(filterValue === "FOLLOWING");
    }

    function renderLink(filterName, filterEnum, paddingStyle) {
        return (
            <Box sx={{ width: "4.75rem" }}>
                <Link onClick={() => onClick(filterEnum)}>
                    <Typography
                        variant="body2"
                        component="div"
                        gutterBottom
                        sx={paddingStyle}
                    >
                        {followingFilter === filterEnum ? (
                            <strong>{filterName}</strong>
                        ) : (
                            filterName
                        )}
                    </Typography>
                </Link>
            </Box>
        );
    }

    return (
        <Box sx={{ marginTop: "1.25rem", marginBottom: "0.75rem", width: "100%", display: "flex", justifyContent: "center" }}>
            <Grid container spacing={0} justifyContent="center">
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", marginTop: "0.5rem" }}>
                    {renderLink("Everyone", "EVERYONE", { paddingRight: "0.75rem" })}
                    {renderLink("Following", "FOLLOWING", { paddingLeft: "0.5rem" })}
                </Grid>
            </Grid>
        </Box>
    );

}


function DisplayNoteTopFilters(props) {

    const karmaContext = useKarmaPoolContext();

    const [topFilter, setTopFilter] = useState("ALL");

    const [numberOfMusicNotes, setNumberOfMusicNotes] = useState(0);

    const [numberOfTextNotes, setNumberOfTextNotes] = useState(0);

    const [numberOfNotes, setNumberOfNotes] = useState(0);

    useEffect(() => {
        setNumberOfMusicNotes(karmaContext.noteManager.getNumberOfMusicNotes());
        setNumberOfTextNotes(karmaContext.noteManager.getNumberOfTextNotes());
        setNumberOfNotes(karmaContext.noteManager.getNumberOfNotes());
    }, [karmaContext.local.noteSummaries]);

    function noteTypeTagClicked(event, tag) {
        event.preventDefault();

        console.log("note type tag " + tag + " clicked");

        if (tag === "All" && numberOfNotes > 0) {
            setTopFilter("ALL");
            props.setLatestNotes(karmaContext.noteManager.getLatestNotes());
            props.setTopFilter("ALL");

            karmaContext.noteManager.setTopFilter({ musicNotesOnly: false, textNotesOnly: false })
        }
        else if (tag === "Music" && numberOfMusicNotes > 0) {
            setTopFilter("MUSIC");
            props.setLatestNotes(karmaContext.noteManager.getMusicNotes());
            props.setTopFilter("MUSIC");

            karmaContext.noteManager.setTopFilter({ musicNotesOnly: true, textNotesOnly: false })
        }
        else if (tag === "Text" && numberOfTextNotes > 0) {
            setTopFilter("TEXT");
            props.setLatestNotes(karmaContext.noteManager.getTextNotes());
            props.setTopFilter("TEXT");

            karmaContext.noteManager.setTopFilter({ musicNotesOnly: false, textNotesOnly: true })
        }

    }

    return (
        <Box sx={{ marginBottom: "0.0rem", width: "100%", display: "flex", justifyContent: "center" }}>
            <Grid container spacing={0}>
                <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.5rem" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        <strong> Note Filter: </strong>
                    </Typography>
                </Grid>
                <Box sx={{ marginBottom: "0.75rem", width: "100%", display: "flex", justifyContent: "center" }}>
                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.5rem" }}>
                        <Box sx={{
                            backgroundColor: "rgba(221, 221, 221, 0.0825)",
                            padding: "0.25rem",
                            width: "16.75rem",
                        }}>
                            <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                <TagComponent tagName={"All"} count={numberOfNotes} selected={topFilter === "ALL"} onClick={noteTypeTagClicked} width={"5.5rem"} />
                                <TagComponent tagName={"Music"} count={numberOfMusicNotes} selected={topFilter === "MUSIC"} onClick={noteTypeTagClicked} width={"5.5rem"} />
                                <TagComponent tagName={"Text"} count={numberOfTextNotes} selected={topFilter === "TEXT"} onClick={noteTypeTagClicked} width={"5.5rem"} />
                            </Grid>
                        </Box>
                    </Box>
                </Box >
            </Grid>
        </Box >
    );
}

function DisplayNoteMoodFilters() {
    return (
        <Box sx={{ marginBottom: "0.75rem", width: "100%", display: "flex", justifyContent: "center" }}>
            <Grid container spacing={0}>
                <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.75rem" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        <strong>Mood Filters:</strong>
                    </Typography>
                </Grid>
                <DisplayNoteMoodFilterCollapsed />
            </Grid>
        </Box>
    );
}

function DisplayNoteMoodFilterCollapsed() {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: "0.5rem", width: "100%" }}>
            <Box sx={{ backgroundColor: "rgba(221, 221, 221, 0.0825)", padding: "0.25rem", width: "19.5rem" }}>
                <Typography variant="body2" component="div" gutterBottom sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    {"<tap to open>"}
                </Typography>
            </Box>
        </Box>
    );
}

function DisplayNoteMoodFilterOpen() {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: "0.5rem", width: "100%" }}>
            <Box sx={{ backgroundColor: "rgba(221, 221, 221, 0.0825)", padding: "0.25rem", width: "19.5rem" }}>
                <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <TagComponent tagName={"#ethereal"} tagType={"MUSIC"} count={1} width={"5.5rem"} />
                    <TagComponent tagName={"#euphoric"} tagType={"MUSIC"} count={2} width={"5.5rem"} />
                </Grid>
                <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <TagComponent tagName={"#happy"} tagType={"MUSIC"} count={0} width={"5.5rem"} />
                    <TagComponent tagName={"#groovy"} tagType={"MUSIC"} count={0} width={"5.5rem"} />
                    <TagComponent tagName={"#nostalgic"} tagType={"MUSIC"} count={0} width={"5.5rem"} />
                </Grid>
                <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <TagComponent tagName={"#hyped"} tagType={"MUSIC"} count={1} width={"5.5rem"} />
                    <TagComponent tagName={"#chilled"} tagType={"MUSIC"} count={2} width={"5.5rem"} />
                    <TagComponent tagName={"#relaxed"} tagType={"MUSIC"} count={1} width={"5.5rem"} />
                </Grid>
                <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <TagComponent tagName={"#melancholic"} tagType={"MUSIC"} count={1} width={"5.5rem"} />
                    <TagComponent tagName={"#angsty"} tagType={"MUSIC"} count={2} width={"5.5rem"} />
                </Grid>
            </Box>
        </Box>
    );
}


function DisplayNoteGenreFilters() {
    return (
        <Box sx={{ marginBottom: "0.75rem", width: "100%", display: "flex", justifyContent: "center" }}>
            <Grid container spacing={0}>
                <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        <strong>Genre Filter:</strong>
                    </Typography>
                </Grid>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.5rem" }}>
                    <Box sx={{ backgroundColor: "rgba(221, 221, 221, 0.0825)", padding: "0.25rem" }}>
                        <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <TagComponent tagName={"#breakcore"} count={2} />
                            <TagComponent tagName={"#alt-pop"} count={2} />
                        </Grid>
                    </Box>
                </Box>
            </Grid>
        </Box>
    );
}


function DashboardSocial() {

    const theme = useTheme();
    const isMediumScreenSize = useMediaQuery(theme.breakpoints.up('sm'));

    const karmaContext = useKarmaPoolContext();

    useEffect(() => {
        karmaContext.noteManager.fetchLatestNotes();
        karmaContext.tagManager.fetchMoodTags();
        karmaContext.tagManager.fetchGenreTags();
    }, []);

    useEffect(() => {
        setLatestNotes(karmaContext.local.latestNotes);
    }, [karmaContext.local.latestNotes]);

    const [latestNotes, setLatestNotes] = useState(() => {
        return karmaContext.local.latestNotes;
    });

    const memoizedSetLatestNotes = useCallback(
        (newNotes) => {
            setLatestNotes(newNotes);
        },
        [] // No dependencies, it won't change between renders
    );

    const [selectedProfile, setSelectedProfile] = React.useState(null);


    return (
        <>
            <Box className={karmaStyles.homepageBox2}>
                <DashboardMenuHeaderComponent
                    socialEnabled={true} />
            </Box>
            <Box className={karmaStyles.homepageBox3}>
                <NoteChoiceComponent />

                <Box sx={{ marginBottom: "0.675rem" }}>
                    <Typography variant="body2" component="div" gutterBottom>
                    </Typography>
                </Box>
                <DisplayNoteFilters latestNotes={latestNotes} setLatestNotes={memoizedSetLatestNotes} />
                <DisplayNoteGrid latestNotes={latestNotes} />

            </Box>
            <Paper sx={{ marginBottom: "16rem" }} />
        </>
    );
}

export default DashboardSocial;